import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconArrowRight, IconInfoCircle } from '@tabler/icons-react';
import styles from './Detail.module.scss';

interface ActionsHintProps {
  text: string;
  onOpen?: () => void;
}

/**
 * The one-line "N open actions relating to …" at the foot of each analysis
 * page. The spec keeps the full list on the Actions page on purpose, so this
 * only counts and links.
 */
const ActionsHint: React.FC<ActionsHintProps> = ({ text, onOpen }) => {
  const { t } = useTranslation('templates');
  return (
    <div className={styles.hint}>
      <span className={styles.hintText}>
        <IconInfoCircle size={18} stroke={1.8} />
        {text}
      </span>
      {onOpen && (
        <button type="button" className={styles.linkButton} onClick={onOpen}>
          {t('report.detail.toActions')}
          <IconArrowRight size={14} stroke={2} />
        </button>
      )}
    </div>
  );
};

export default ActionsHint;
